(function(angular){
    "use strict";
    angular.module('smartpublic.core',[]);
    
})(angular);